import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { theme } from '../theme';
import { focusOutline } from '../utils/focusOutline';
export const Toggle = ({ id, checked, onToggle, disabled, bgColor, ...marginProps }) => {
    return (React.createElement(Switch, { forwardedAs: "label", htmlFor: id, ...marginProps },
        React.createElement(Checkbox, { id: id, disabled: disabled, type: "checkbox", checked: checked, onChange: onToggle, "$bgColor": bgColor, onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    onToggle();
                }
            }, "aria-label": "toggle" }),
        React.createElement(Slider, { "$disabled": disabled })));
};
const Switch = styled(Box) `
  position: relative;
  display: inline-block;
  width: 56px;
  height: 32px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;
const Slider = styled.span `
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.colors.oatmeal};
  border: none;
  border-radius: 28px;
  transition: 0.2s background-color;
  outline: none;

  &:before {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 4px;
    bottom: 4px;
    background-color: ${theme.colors.mascarpone};
    transition: 0.2s transform;
    border-radius: 50%;
  }

  ${({ $disabled }) => $disabled
    ? css `
          cursor: not-allowed;
        `
    : css `
          &:hover {
            background-color: ${theme.colors.marzipan};
          }
        `}
`;
const Checkbox = styled.input `
  ${focusOutline({ selector: `&:focus-visible + ${Slider}` })}

  &:checked + ${Slider} {
    background-color: ${(props) => props.$bgColor ? theme.colors[props.$bgColor] : theme.colors.pistachio};
    border: none;
  }

  &:checked + ${Slider}:before {
    transform: translateX(24px);
  }
`;
//# sourceMappingURL=Toggle.js.map